<!--  -->
<template>
    <div class="popup-container">
      <van-popup v-bind="$attrs" v-on="$listeners">
        <div class="popup__title">{{$t('homePage.stayTuned')}}</div>
        <div class="popup-nft__pics">
          <div class="popup-nft__pics--item nft-pic1"></div>
          <div class="popup-nft__pics--item nft-pic2"></div>
          <div class="popup-nft__pics--item nft-pic3"></div>
        </div>
        <div class="popup-nft__desc">{{$t('homePage.stayDesc')}}</div>
        <div class="popup__footer">
          <div class="popup__left__btn" @click="handleClose">{{$t('homePage.close')}}</div>
          <div class="popup__right__btn" @click="toKyc">{{$t('homePage.kycVerification')}}</div>
        </div>
      </van-popup>
    </div>
</template>

<script>
import Cookie from '@/api/cookie';

export default {
  data() {
    return {
    };
  },
  props: {
    currProduct: Object,
  },
  components: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {
    handleClose() {
      this.$emit('input', false);
    },
    toKyc() {
      if (!Cookie.getItem('token')) {
        window.location.href = 'https://mal.io/login';
        return;
      }
      window.location.href = 'https://mal.io/personal/id-auth';
      // this.$router.push('/personal/id-auth');
    },
  },
};
</script>

<style lang='stylus' scoped>
.van-popup {
  padding: 16px 40px 24px;
  box-sizing: border-box;
  width: 364px;
  border-radius: 5px;
}

.popup__title {
  font-size: 18px;
  color: #000000;
  font-weight: 500;
  margin-bottom: 19px;
}

.popup-nft__pics {
  display: flex;
  align-items: center;

  &--item {
    flex: 0 0 64px;
    height: 64px;
    margin-right: 12px;
    background: #999;
  }
}

.popup-nft__desc {
  font-size: 14px;
  font-weight: 400;
  color: #6D7278;
  line-height: 20px;
  margin-top: 17px;
}

.popup__footer {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.popup__left__btn,
.popup__right__btn {
  flex: 0 0 134px;
  height: 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.popup__left__btn {
  border-radius: 4px;
  border: 1px solid #000000;
  font-size: 14px;
  color: #000;
}

.popup__right__btn {
  background: #0CC267;
  border-radius: 4px;
  font-size: 14px;
  color: #fff;
}
.nft-pic1 {
  background: url('~@/assets/images/home/nft-pic1.png') no-repeat top center/cover;
}
.nft-pic2 {
  background: url('~@/assets/images/home/nft-pic2.png') no-repeat top center/cover;
}
.nft-pic3 {
  background: url('~@/assets/images/home/nft-pic3.png') no-repeat top center/cover;
}
</style>
